import { PayloadAction } from "@reduxjs/toolkit";
import { ProposalState } from "..";
import { ProductConditionType } from "../types/productConditionTypes";
import { constructProductsCommercialCondition } from "../../../../utils/commercialConditions/constructProductCondition";

// Short proposal product conditions
type AddProductConditionsParams = {
  productIds: number[];
  commercialValues?: ProductConditionType[];
};

function AddProductConditionsReducer(
  state: ProposalState,
  {
    payload: { productIds, commercialValues },
  }: PayloadAction<AddProductConditionsParams>,
) {
  const formattedProductConditions = constructProductsCommercialCondition(
    productIds,
    commercialValues,
  );

  formattedProductConditions.forEach((form) => {
    state.productByFormId[form.formId] = form;

    const newFormIds = Object.keys(state.productByFormId);
    state.productFormIds = newFormIds;
  });
}

export default AddProductConditionsReducer;
